export const copyToClip = content => {
  var aux = document.createElement("input");
  aux.setAttribute("value", content);
  aux.setAttribute("style", "display:hide");
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");
  document.body.removeChild(aux);
};
